<template>
	<div>
		<span class="text-primary">
			<i 
				class="fa fa-hourglass-half fa-lg icon-button" 
				title="Exibir Timeline" 
				@click.stop="mostrarTimeline()"
			></i>
		</span>
		<b-modal 
			hide-footer 
			size="xl" 
			v-model="mostrarModal" 
			@show="obterTimeLine()" 
			title="TIMELINE"
		>
			<time-line 
				:itens="itensTimeLine" 
				:isModal="true"
			></time-line>
		</b-modal>

	</div>
</template>

<script>
import TimeLine from './../../../shared/components/TimeLine'

export default {
  props: {
    pagamentosServicos: {
        type: Object,
        required: true,
        default: () => ({})
    },
    comprometimento: {
      type: Object,
      required: true,
      default: () => ({}) 
    }
  },

  data() {
    return {
			mostrarModal: false,
      itensTimeLine: null
    }
  },

  methods: {
    mostrarTimeline() {
			this.mostrarModal = true
		},

    obterTimeLine() {
      this.pagamentosServicos.obterTimeLineComprometimento(this.comprometimento.idComprometimento).then(
        response => {
          if (response){
            if (response.success) {
              this.itensTimeLine = response.data
            } else {
              this.$toast.error(
                "Erro ao obter timeline",
                "ERROR",
                this.$toastConfig.error
              );
            }
          }
        })
    }
  },

  components: {
    TimeLine
  },

}       
</script>

<style>
</style>